export var DATA_FLIP_ID = "data-flip-id";
export var DATA_INVERSE_FLIP_ID = "data-inverse-flip-id";
export var DATA_FLIP_COMPONENT_ID = "data-flip-component-id";
export var DATA_FLIP_CONFIG = "data-flip-config";
export var DATA_PORTAL_KEY = "data-portal-key";
export var DATA_EXIT_CONTAINER = "data-exit-container";